<template>
  <div>
    <div class="d-flex">
      <nav id="breadcrumbs" class="mb-3">
        <ul>
          <li>
            <router-link :to="{ name: 'company.dashboard' }">
              <i class="uil-home-alt"></i>
            </router-link>
          </li>
          <li> {{ $t('general.solution_partners_apps') }}</li>
        </ul>
      </nav>
    </div>
    <div class="section-header mb-lg-2 border-0 uk-flex-middle">
      <div class="section-header-left">
        <h2 class="uk-heading-line text-left">
          <span> {{ $t('general.solution_partners_apps') }}</span>
        </h2>
      </div>
    </div>
    <template v-if="errorMessages">
      <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: red">
          <i class="uil-exclamation-triangle"></i> {{ error }}
        </p>
      </div>
    </template>
    <div v-if="successMessage" class="uk-alert-success" uk-alert>
      <a class="uk-alert-close" uk-close></a>
      <p style="color: green">
        <i class="uil-exclamation-triangle"></i> {{ successMessage }}
      </p>
    </div>

    <div v-else class="chats-container margin-top-0">
      <div class="chats-container-inner">
        <!-- chats -->
        <div class="chats-inbox for_megaphone">
          <div style="padding:22px 30px">
            <default-loading v-if="isLoading"/>
              <div v-else>
                <div v-for="(partner, index) in partners" :key="partner.id">
                  <partner-card 
                    :partner="partner"
                    :show-status-toggle="true"
                    @connect="refreshAndOpen"
                    @status-changed="handleStatusChanged"
                    @status-error="handleStatusError"
                  />
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import DefaultLoading from "@/view/components/loading/DefaultLoading.vue";
import PartnerCard from "@/view/components/card/PartnerCard.vue";
import axios from "axios";

export default {
  name: "SolutionPartnersList",
  components: { DefaultLoading, PartnerCard },
  data() {
    return {
      toggleActive: [],
      activeItem: null,
      successMessage: null,
      errorMessages: [],
      page: 1,
      per_page: 10,
      filter: {
        search: null,
        sort: "id",
        order: "desc",
      },
      partners: [],
      selectedIntegration: '',
      integrationId: '',
      isLoading: false,

    };
  },
  computed: {
    error: {
      get() {
        // return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
  },

  methods: {
    getResult() {
      this.isLoading = true;

      axios
          .get('api/admin/partners', { headers: this.apiHeaders })
          .then((result) => {
            this.partners = result.data.data;
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    refreshAndOpen(partner) {
      this.getResult();

      setTimeout(() => {
        const url = partner.connect_url || partner.default_url;
        window.open(url, '_blank');
      }, 10);
    },
    handleStatusChanged({ partner }) {
      const index = this.partners.findIndex(p => p.id === partner.id);
      if (index !== -1) {
        const currentPartner = this.partners[index];
        const updatedPartner = {
          ...currentPartner,
          ...partner
        };
        this.$set(this.partners, index, updatedPartner);
      }
    },
    handleStatusError({ partner, error }) {
      this.errorMessages = [this.$t('general.update_error') || 'Durum güncellenirken hata oluştu.'];
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
  },
  mounted() {
    this.getResult();
  },
  watch: {
    "filter.search": function (val) {
      this.debouncedFilterSearch();
    },
    successMessage: function (val) {
      this.debouncedResetValues();
    },
    errorMessages: function (val) {
      this.debouncedResetValues();
    },
  },
};
</script>


<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.uk-switch {
  height: 24px;
  width: 50px;
}

.uk-switch-slider:before {
  width: 20px;
  height: 20px;
}

.custom-save-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #3E416D !important;
  color: white !important;
  border: none;
}
.custom-save-button i{
 color: white !important;
    font-size: 24px;
 
}

.custom-save-button:hover {
  background-color: #0056ae !important;
  /* Daha koyu bir hover efekti */
}

.modal-w-600 {
  width: 600px;
}

.modal-w-900 {
  width: 900px;
}


.uk-light .uk-switch-slider:not(.uk-switch-on-off) {
  background-color: #e6e6e6;
}
</style>

